import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "text", "children", "onClick"];
import React from 'react';
import copy from '@uiw/copy-to-clipboard';
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CopyToClipboard(props) {
  var {
      prefixCls = 'w-copy-to-clipboard',
      className,
      text = '',
      children,
      onClick = () => null
    } = props,
    resetProps = _objectWithoutPropertiesLoose(props, _excluded);
  function handleClick(e) {
    if (!text) {
      return onClick('', false, e);
    }
    copy(text, isCopy => {
      onClick(text, isCopy, e);
    });
  }
  var otherProps = _extends({}, resetProps, {
    className: [prefixCls, className].filter(Boolean).join(' ').trim(),
    onClick: handleClick
  });
  return /*#__PURE__*/_jsxs("span", _extends({}, otherProps, {
    children: [/*#__PURE__*/_jsx("span", {
      className: prefixCls + "-select",
      children: text
    }), children]
  }));
}